import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="error-page">
      <h1>404 Not Found</h1>
      <p>The page you are looking for does not exist. It might have been moved or deleted.</p>
      <Link to="/">Go back to Home</Link>
    </div>
  );
};

export default NotFoundPage;
